import { Component, OnDestroy, OnInit } from '@angular/core';
import { takeUntilDestroyed } from 'src/app/utils/take-until-destroyed';
import * as moment from 'moment-timezone';
import { takeUntil } from 'rxjs/operators';
import { SharedDataService } from 'src/app/service/shared-service/shared-data.service';

@Component({
  selector: 'app-z-dates',
  templateUrl: './z-dates.component.html',
  styleUrls: ['./z-dates.component.css']
})
export class ZDatesComponent implements OnInit, OnDestroy {
  timeZone;

  constructor(
    private sharedDataService: SharedDataService
  ) { }

  ngOnInit() {
    this.sharedDataService
      .getUser()
      .pipe(takeUntil(takeUntilDestroyed(this)))
      .subscribe(user => {
        if (user) {
          this.timeZone = user.timeZone;
        }
      })
  }



  ngOnDestroy(): void {
  }
}
